import { useState, useEffect } from 'react';

/**
 * Hook to detect mobile devices and reduced motion preferences
 * for performance optimizations
 */
export const usePerformance = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
    const [isLowEndDevice, setIsLowEndDevice] = useState(false);

    useEffect(() => {
        // Check if mobile device
        const checkMobile = () => {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
            const isSmallScreen = window.innerWidth < 768;
            return isMobileDevice || isSmallScreen;
        };

        // Check for reduced motion preference
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        setPrefersReducedMotion(mediaQuery.matches);

        // Check for low-end device (based on hardware concurrency and device memory)
        const checkLowEnd = () => {
            const cores = navigator.hardwareConcurrency || 4;
            const memory = navigator.deviceMemory || 4;
            return cores <= 4 || memory <= 4;
        };

        setIsMobile(checkMobile());
        setIsLowEndDevice(checkLowEnd());

        const handleResize = () => {
            setIsMobile(checkMobile());
        };

        const handleMediaChange = (e) => {
            setPrefersReducedMotion(e.matches);
        };

        window.addEventListener('resize', handleResize);
        mediaQuery.addEventListener('change', handleMediaChange);

        return () => {
            window.removeEventListener('resize', handleResize);
            mediaQuery.removeEventListener('change', handleMediaChange);
        };
    }, []);

    return { isMobile, prefersReducedMotion, isLowEndDevice };
};

